import BannerModule from './banner.module'

export default BannerModule
